<template>
  <div class="home">
    <section id="header-home" class="d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <div class="brand-sinsaude">
              <img src="@/img/brand-drachei-card.svg" alt="Dr.Achei Card">
            </div>
            <br>
            <h2 class="mb-3 col-xs-12">CADASTRE-SE AGORA E SEJA ENCONTRADO POR PACIENTES EM TODO BRASIL</h2>
            <!--<p>ALÉM DO AGENDAMENTO E PAGAMENTO ONLINE</p>  -->
            <router-link tag="a" class="btn btn-primary btn-lg" :to="{name: 'Precadastro'}">Fazer Cadastro</router-link>
          </div>
        </div>
      </div>
    </section>
    <section id="vantagens">
      <div class="container">
        <h4 class="display-3">
          VANTAGENS DE FAZER PARTE DO DR.ACHEI / DR.ACHEI CARD
        </h4>
        <div class="row">
          <div class="col-md-4 col-xs-12 text-center">
            <div class="vantagem-item">
              <img src="@/img/calendar.svg" class="img-fluid" alt="">
              <h5>Agendamento Online</h5>
              <p>Envio de SMS e e-mail de suas consultas agendadas pelo nosso aplicativo</p>
            </div>
          </div>
          <div class="col-md-4 col-xs-12 text-center">
            <div class="vantagem-item">
              <img src="@/img/like.svg" class="img-fluid" alt="">
              <h5>Conquiste mais clientes</h5>
              <p>Oportunidade de divulgação do seu currículo e experiência profissional.</p>
            </div>
          </div>
          <div class="col-md-4 col-xs-12 text-center">
            <div class="vantagem-item">
              <img src="@/img/credit-card.svg" class="img-fluid" alt="">
              <h5>Pagamento Online</h5>
              <p>Receba seus honorários em até 24 horas úteis após a consulta ou procedimento realizado.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
             <router-link tag="a" class="btn btn-primary btn-lg" :to="{name: 'Precadastro'}">Fazer Meu Cadastro</router-link>
          </div>
        </div>
      </div>
      <div class="container mt-5 outras-vantagens-list">
        <div class="row ">
          <div class="col">
            <h4 class="display-4">Outras vantagens</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <ul>
              <li><i class="fas fa-sort-amount-up"></i> Aumente sua carteira de clientes e seu faturamento</li>
              <li><i class="fas fa-stopwatch"></i> Receba seus honorários em até 24 horas úteis após a consulta ou procedimento realizado</li>
              <li><i class="fas fa-clipboard-check"></i> Não tem glosa e burocracia</li>
              <li><i class="far fa-calendar-alt"></i> Controle de Agenda online</li>
            </ul>
          </div>
          <div class="col-md-4 col-xs-12">
            <ul>
              <li><i class="fas fa-user-md"></i> Crie seu perfil profissional</li>
              <li><i class="fas fa-user-clock"></i> Você define seus horários de atendimento</li>
              <li><i class="fas fa-bullhorn"></i> Oportunidade de divulgação do seu currículo e experiência profissional</li>
              <li><i class="fas fa-cloud-upload-alt"></i> Dados na nuvem criptografados e com segurança,</li>
            </ul>
          </div>
          <div class="col-md-4 col-xs-12">
            <ul>
              <li><i class="fas fa-envelope"></i> Envio de SMS e e-mail de suas consultas agendadas pelo nosso aplicativo</li>
              <li><i class="fas fa-star-half-alt"></i> Seus pacientes te avaliam proporcionando maiores indicações</li>
              <li><i class="fab fa-creative-commons-nc"></i> Sem mensalidade</li>
              <li><i class="fab fa-creative-commons-nc"></i> Sem taxa de adesão</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section id="como-funciona">
      <div class="container">
        <h4 class="display-3">
          Como Funciona?
        </h4>
        <div class="col-md-10 offset-md-1">
          <img src="@/img/howworks.png" class="img-fluid" alt="">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FormBusca from '@/components/busca/FormBusca'

export default {
  components: {
    'form-busca': FormBusca
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/pages/PageProfissionais.vue